"use client";

import { ButtonLink, TCommonBentoGridSection } from "@shared/cms";
import { BentoCard } from "@shared/ui";
import { cn } from "@ubud-ui/react-ui-kit";

export function CommonBentoGridSection({ title, subtitle, backgroundColor, colSize, grids, button, footnote }: TCommonBentoGridSection) {
  const backgroundVariants: Record<"gray" | "white", string> = {
    gray: "bg-gray-50",
    white: "bg-white",
  };

  const colSizeVariants: Record<"one" | "two", string> = {
    one: "grid-cols-1",
    two: "grid-cols-1 lg:grid-cols-2",
  };

  return (
    <section className={cn("py-14 md:py-24 md:mt-10", backgroundVariants[backgroundColor])}>
      <div className="container">
        <div className="space-y-4 text-gray-700 text-center max-w-[37.5rem] mx-auto">
          {subtitle && <div className="text-lg sm:text-xl font-medium">{subtitle}</div>}
          <div className="text-2xl sm:text-4xl font-bold">{title}</div>
        </div>
        {grids && grids.length > 0 && (
          <div className="mt-[3.75rem]">
            <div className={cn("grid gap-6", colSizeVariants[colSize])}>
              {grids.map((grid) => {
                return (
                  <div key={grid.id} className={cn("grid gap-6", colSizeVariants[grid.colSize])}>
                    {grid.cards.map((card) => {
                      return <BentoCard key={card.id} {...card} />;
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {(footnote || button) && (
          <div className="mt-10 sm:mt-16 flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            {footnote && <div className="text-sm sm:text-base font-medium text-gray-700 text-center">{footnote}</div>}
            {button && <ButtonLink {...button} />}
          </div>
        )}
      </div>
    </section>
  );
}
